import axios from 'axios';
import ProviderSubtypeTransformer from '../../transformers/providerSubtypeTransfomer';

export default () => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'providers/subtypes?paginate=false')
      .then(({ data }) => {
        const providersubTypes = [];

        if (data) {
          data.data.forEach((type) => {
            providersubTypes.push(ProviderSubtypeTransformer.fetch(type));
          });
        }
        resolve(providersubTypes);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
